import React from 'react';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import PerfilData from '../../Components/Admin/Perfil/PerfilData';

export default function Perfil() {
    return (
        <div className="containerGrid">
            <Header />
            <section className="containerSection">
                <HeaderDash />
                <div className="container">
                    <PerfilData />
                </div>
            </section>
        </div>
    );
}
